// extracted by mini-css-extract-plugin
export default {"filter":"styles_filter__MAkRM","text":"styles_text__L1nQg","filterIcon":"styles_filterIcon__PNmMj"};